import { render, staticRenderFns } from "./PopupUpsellConformation.vue?vue&type=template&id=5074424c"
import script from "./PopupUpsellConformation.vue?vue&type=script&lang=js"
export * from "./PopupUpsellConformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports